import React from 'react';
import { Radio, Loader2 } from 'lucide-react';
import LoteDetalleContent from '../../components/LoteDetalleContent';

/**
 * LoteEnCursoSection - Live lot section with red border
 */
const LoteEnCursoSection = ({
    loteEnCurso,
    loteEnCursoData,
    loadingLoteEnCursoData,
    pique
}) => {
    return (
        <div className="mb-8">
            {/* Header del lote en vivo */}
            <div className="bg-gradient-to-r from-red-600 to-red-500 rounded-t-2xl px-4 lg:px-6 py-3 lg:py-4 flex flex-wrap items-center justify-between gap-3 lg:gap-4">
                <div className="flex items-center gap-3 lg:gap-4">
                    <div className="flex items-center gap-2">
                        <div className="relative">
                            <Radio className="w-5 h-5 lg:w-6 lg:h-6 text-white" />
                            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 lg:w-3 lg:h-3 bg-white rounded-full animate-ping" />
                            <span className="absolute -top-1 -right-1 w-2.5 h-2.5 lg:w-3 lg:h-3 bg-white rounded-full" />
                        </div>
                        <span className="text-white font-black text-base lg:text-lg uppercase tracking-wider">En Vivo</span>
                    </div>
                    <div className="h-6 w-px bg-white/30 hidden sm:block" />
                    <div className="text-white">
                        <span className="text-white/70 text-xs lg:text-sm">Lote en curso:</span>
                        <span className="font-bold text-lg lg:text-xl ml-2">#{loteEnCurso}</span>
                    </div>
                </div>

                <div className="flex items-center gap-3 lg:gap-4">
                    {/* Número de teléfono para ofertar */}
                    <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-xl px-3 lg:px-4 py-1.5 lg:py-2 border border-white/30">
                        <svg className="w-4 h-4 lg:w-5 lg:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                        <div>
                            <span className="text-white/70 text-[10px] lg:text-xs font-semibold block">Ofertá por teléfono</span>
                            <span className="text-white font-bold text-sm lg:text-lg">0800 8122</span>
                        </div>
                    </div>

                    {pique > 0 && (
                        <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 lg:px-6 py-1.5 lg:py-2 border border-white/30 text-center">
                            <span className="text-white/70 text-[10px] lg:text-xs font-semibold uppercase tracking-wide">Oferta actual</span>
                            <p className="text-white font-black text-xl lg:text-2xl animate-[heartbeat-subtle_2s_ease-in-out_infinite]">${pique}</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Contenido del lote en vivo - CON BORDE ROJO */}
            <div className="bg-white rounded-b-2xl shadow-2xl border-2 border-red-300 border-t-0 overflow-hidden">
                {loadingLoteEnCursoData ? (
                    <div className="flex items-center justify-center py-12 lg:py-16">
                        <Loader2 className="w-8 h-8 lg:w-10 lg:h-10 animate-spin text-red-500" />
                        <span className="ml-3 text-gray-600 font-medium text-sm lg:text-base">Cargando lote en vivo...</span>
                    </div>
                ) : loteEnCursoData ? (
                    <LoteDetalleContent
                        lote={loteEnCursoData}
                        showHeader={false}
                        showButtons={false}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default LoteEnCursoSection;
